<!-- 
<div style="width: 300px;height: 40px;display: flex;justify-content: center;">
    <img style="height: 80%; width: 50%;" src="../assets/vaadude_old.png">
</div> -->
<div style="width: 300px;">
   
    <span style="color:#a00c43 ;">Vaa</span ><span style="color: #17005e;">dude.com</span> 
    <span style="color:#666666 ;">
    is a social networking site where IT professionals can read and exchange news, technical conversation, and job posting.
    </span>
</div>
<div style="width: 300px;display: flex;justify-content: end;margin-top: 10px;"  >
        <button style="background-color: #2265f3;color: white;padding: 0px 5px;border: solid 2px #2265f3;
        border-radius: 5px;" (click)="closePopup()">close</button>
</div>